/**
 * addLock appends a new lock onto the held locks array.
 */
export const addLock = (state, {key}) => {
  if (state.locks.find(l => l.key === key)) {
    return;
  }

  state.locks = [
    ...state.locks,
    {
      key: key,
      error: '',
    },
  ];
};

/**
 * setLock overwrites a lock in the held locks array.
 */
export const setLock = (state, payload) => {
  const lock = state.locks.find(l => l.key === payload.key);
  if (!lock) {
    return;
  }

  state.locks = [
    ...state.locks.filter(l => l.key !== payload.key),
    payload,
  ];
};

/**
 * removeLock clears an existing lock from held locks array.
 */
export const removeLock = (state, key) => {
  const lock = state.locks.find(l => l.key === key);
  if (!lock) {
    return;
  }

  state.locks = [
    ...state.locks.filter(l => l.key !== key),
  ];
};
